<div class="">
  <mat-spinner diameter="70" color="primary"></mat-spinner>
</div>
